{
  "error-title": "Ошибка",
  "error-desc": "Ошибка при загрузке",
  "empty-msg": "Не найдено"
}
